import React from 'react';
import { Button, IconExternalLink, Link } from 'gatorcomponents';
import * as Styles from './FaqDefaultV2.styles';
import { locale } from '@/utils/locale';

const FaqDefaultV2 = ({
  questions,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
  width,
  height = 'fit',
  showSameWithoutQuestions = false,
  testId,
}) => {
  if (!showSameWithoutQuestions && (!questions || questions.length === 0)) {
    return null;
  }
  return (
    <Styles.Wrapper width={width} data-testid={testId}>
      <Styles.Card height={height}>
        <Styles.Content>
          <Styles.Title>{locale('help.frequentlyQuestions')}</Styles.Title>
          <Styles.LinksContainer>
            {questions.map((questionItem, index) => (
              <Styles.LinkItem key={questionItem.id}>
                <Link
                  href={questionItem.link}
                  text={questionItem.question}
                  target="_blank"
                  testId={`faq-link-${index}`}
                />
                <Styles.IconWrapper>
                  <IconExternalLink size="sm" color="primaryBlue" secondaryColor="transparent" />
                </Styles.IconWrapper>
              </Styles.LinkItem>
            ))}
          </Styles.LinksContainer>
        </Styles.Content>
        <Styles.ButtonsContainer $isHalfWidth={width === 'half'}>
          {onPrimaryAction && (
            <Button
              label={primaryActionLabel}
              variant="secondary"
              size="medium"
              width="fit"
              onClick={onPrimaryAction}
              testId="primary-action-button"
            />
          )}
          {onSecondaryAction && (
            <Button
              label={secondaryActionLabel}
              variant="tertiary"
              size="medium"
              width="fit"
              onClick={onSecondaryAction}
              testId="secondary-action-button"
            />
          )}
        </Styles.ButtonsContainer>
      </Styles.Card>
    </Styles.Wrapper>
  );
};

export default FaqDefaultV2;
